import { connect } from 'react-redux';
import SearchBuku from '../../../views/Library/SearchBuku/SearchBuku.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(SearchBuku);
